import { render, staticRenderFns } from "./editFileDEscribeDialog.vue?vue&type=template&id=0d89e5c4"
import script from "./editFileDEscribeDialog.vue?vue&type=script&lang=js"
export * from "./editFileDEscribeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports